import BaseApi from './BaseApi';

class LpAnalyticsApi extends BaseApi {
  public getLpAnalyticsExport(params: any) {
    return this.get('/export', params);
  }

  protected getSpecificApiPrefix(): string {
    return 'v2/managers/lp-analytics';
  }
}

export default LpAnalyticsApi;
